<template>
  <div class="rounded-lg border border-cyan-400/25 bg-slate-950/35 p-3 space-y-3">
    <div class="flex items-start justify-between gap-3">
      <div>
        <h4 class="text-sm font-medium text-slate-200">Base de conhecimento (RAG)</h4>
        <p class="text-xs text-slate-400 leading-snug mt-0.5">
          Faça upload de documentos, informe URLs e, se precisar (ex.: Zendesk privado), associe endpoints de API de
          <strong>leitura</strong>. Depois clique em <strong>Reindexar</strong> para atualizar a base.
        </p>
      </div>
      <button
        type="button"
        class="whitespace-nowrap text-xs px-3 py-2 rounded border border-cyan-400/40 text-cyan-200 hover:bg-cyan-400/10 disabled:opacity-60"
        :disabled="knowledgeReindexing || !editingId"
        :title="!editingId ? 'Salve o agente antes de reindexar' : 'Reindexar base'"
        @click="$emit('reindex')"
      >
        {{ knowledgeReindexing ? 'Reindexando…' : 'Reindexar' }}
      </button>
    </div>

    <AgentDocuments
      :documents="knowledgeDocuments"
      :pending-files="knowledgeFiles"
      :allow-upload="!!editingId"
      :uploading="knowledgeUploading"
      :file-input-key="knowledgeFileInputKey"
      @files-selected="$emit('files-selected', $event)"
      @remove-document="$emit('remove-document', $event)"
    />
    <AgentUrls
      :urls="urls"
      @add-url="$emit('add-url')"
      @remove-url="$emit('remove-url', $event)"
      @update-url="$emit('update-url', $event)"
    />

    <AgentConnectorEndpoints
      :options="filteredApiEndpointOptions"
      :selected-id="selectedApiEndpointToAdd"
      :selected-ids="form.api_connector_endpoint_ids"
      @update:selectedId="$emit('update:selectedApiEndpointToAdd', $event)"
      @add="$emit('add-api-endpoint')"
      @remove="$emit('remove-api-endpoint', $event)"
    />

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
      <div class="rounded-lg border border-slate-600/70 bg-slate-900/25 p-3">
        <p class="text-xs text-slate-400">Última execução</p>
        <p class="text-sm text-slate-100">{{ lastReindexDisplayAt }}</p>
      </div>
      <div class="rounded-lg border border-slate-600/70 bg-slate-900/25 p-3">
        <p class="text-xs text-slate-400">Status</p>
        <p class="text-sm text-slate-100">{{ lastReindexRun?.status || '—' }}</p>
      </div>
      <div class="rounded-lg border border-slate-600/70 bg-slate-900/25 p-3">
        <p class="text-xs text-slate-400">Erro</p>
        <p class="text-sm text-slate-100 break-words">{{ lastReindexRun?.error_message || '—' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import AgentDocuments from './AgentDocuments.vue'
import AgentUrls from './AgentUrls.vue'
import AgentConnectorEndpoints from './AgentConnectorEndpoints.vue'

export default {
  name: 'AgentSpecialtyKnowledgeForm',
  components: { AgentDocuments, AgentUrls, AgentConnectorEndpoints },
  props: {
    form: { type: Object, required: true },
    filteredApiEndpointOptions: { type: Array, default: () => [] },
    selectedApiEndpointToAdd: { type: [Number, null], default: null },
    editingId: { type: [Number, String, null], default: null },
    knowledgeReindexing: { type: Boolean, default: false },
    knowledgeFiles: { type: Array, default: () => [] },
    knowledgeDocuments: { type: Array, default: () => [] },
    knowledgeUploading: { type: Boolean, default: false },
    knowledgeFileInputKey: { type: Number, default: 0 },
    /** Resposta API `last_knowledge_reindex_run` (registro da última reindexação). */
    lastReindexRun: { type: Object, default: null },
    urls: { type: Array, default: () => [] }
  },
  computed: {
    lastReindexDisplayAt() {
      const r = this.lastReindexRun
      if (!r) return '—'
      return r.finished_at || r.started_at || r.created_at || '—'
    }
  },
  emits: [
    'reindex',
    'files-selected',
    'remove-document',
    'add-url',
    'remove-url',
    'update-url',
    'update:selectedApiEndpointToAdd',
    'add-api-endpoint',
    'remove-api-endpoint'
  ]
}
</script>
